import { ProviderType } from '@karehero/models';

import { ShortlistedCareHomeCard } from '../ShortlistedCareHomeCard/ShortlistedCareHomeCard';

interface ProviderCardProps {
  provider: ProviderType;
  variant?: 'long';
  onReadMoreClick?: (val: string) => void;
}

export const ProviderCard = ({
  provider,
  provider: {
    careType,
    name,
    regulatoryId,
    enquiryPhone,
    address,
    coverPhoto,
    pricePerWeek,
    ratings,
    distance,
    availability,
    careServiceTypes,
    minimumVisitTime,
    hourlyRate,
  },
  variant,
  onReadMoreClick,
}: ProviderCardProps) => {
  const coverPhotoSourcePath = coverPhoto ? coverPhoto?.medium : undefined;

  const oneLineAddress = [
    address?.streetAddress1,
    address?.city,
    address?.postcode,
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <ShortlistedCareHomeCard
      variant={variant}
      isShowShortlistDetails={false}
      regulatoryID={regulatoryId}
      headerImageUrl={coverPhotoSourcePath}
      name={name}
      address={oneLineAddress}
      rating={ratings?.overallRating || ''}
      phone={enquiryPhone}
      careServiceType={careServiceTypes?.map((t, i) => ({ id: i, name: t }))}
      available={availability}
      careType={careType}
      pricePerWeek={pricePerWeek}
      distance={distance}
      provider={provider}
    />
  );
};

export default ProviderCard;
